import React, { useState, useEffect, useRef } from "react";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "../styles/Dashboard.css";

export default function DashboardNavbar() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const profileDropdownRef = useRef(null);

  useEffect(() => {
    const fetchUserName = async () => {
      if (auth.currentUser) {
        try {
          const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setUserName(userData.name || auth.currentUser.displayName || auth.currentUser.email?.split('@')[0] || 'User');
            setUserEmail(userData.email || auth.currentUser.email);
            setUserRole(userData.role || "User");
          } else {
            setUserName(auth.currentUser.email?.split('@')[0] || 'User');
            setUserEmail(auth.currentUser.email);
            setUserRole("User");
          }
        } catch (error) {
          console.error("Error fetching user name:", error);
          setUserName(auth.currentUser.email?.split('@')[0] || 'User');
          setUserEmail(auth.currentUser.email);
          setUserRole("User");
        }
      }
    };

    fetchUserName();
  }, []);



  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    if (isProfileOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProfileOpen]);

  const handleProfileClick = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  const handleViewProfile = () => {
    navigate("/profile");
    setIsProfileOpen(false);
  };

  return (
    <div className="dashboard-navbar">
      <h1 className="dashboard-title">Hi, {userName}</h1>

      <div className="navbar-right">
        <div className="profile-dropdown-container" ref={profileDropdownRef} style={{ position: 'relative' }}>
          <button
            onClick={handleProfileClick}
            className="profile-btn"
            style={{ border: "none", background: "none", cursor: "pointer", fontSize: "24px", display: 'flex', alignItems: 'center' }}
          >
            <FaUserCircle className="icon avatar" title="Profile" />
          </button>

          {isProfileOpen && (
            <div className="profile-dropdown" style={{
              position: 'absolute',
              top: '120%',
              right: 0,
              width: '280px',
              background: '#FFFFFF',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              border: '1px solid #E5E7EB',
              zIndex: 1000,
              padding: '16px',
              animation: 'fadeIn 0.2s ease'
            }}>
              <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(135deg, #5B8DEF 0%, #4F7CFF 100%)',
                  borderRadius: '50%',
                  margin: '0 auto 12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '24px',
                  fontWeight: 'bold'
                }}>
                  {userName.charAt(0).toUpperCase()}
                </div>
                <h3 style={{ margin: '0 0 4px', fontSize: '18px', color: '#1A1A1A' }}>{userName}</h3>
                <p style={{ margin: '0 0 4px', fontSize: '14px', color: '#6B7280' }}>{userEmail}</p>
                <span style={{
                  display: 'inline-block',
                  padding: '4px 12px',
                  background: '#EEF2FF',
                  color: '#5B8DEF',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: '500'
                }}>
                  {userRole === 'freelancer' ? 'Partner' : userRole}
                </span>
              </div>
              <button
                onClick={handleViewProfile}
                style={{
                  width: '100%',
                  padding: '10px',
                  background: 'linear-gradient(135deg, #5B8DEF 0%, #4F7CFF 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '14px'
                }}
              >
                View Full Profile
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
